/* eslint-env browser */

'use strict';

const { setShellEventOrRun } = require('@grpn/shell-page');
require('./index.styl');

require('../base/index.js');

const {
  critModules,
  nonCritModules,
  pageReadyModules,
} = require('./js_modules');

const jsInitializer = require('../initializers/js_initializer');

setShellEventOrRun(() =>
  jsInitializer
    .addJsFiles(critModules, nonCritModules, pageReadyModules)
    .initialize()
);
